import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Address } from './address.model';
import { environment } from '../../../environments/environment'


@Injectable()
export class AddressService {


    constructor(
        private http: HttpClient
    ) { }

    get(cepid: string): Observable<Address> {
        return this.http.get<Address>(`${environment.api}/ceps/${cepid}`)
    }


}
